/**
 * CIMA-specific Auth0 configuration.
 * Do NOT import or reuse the BiziOps auth config.
 */
export const cimaAuth0Config = {
    domain: process.env.REACT_APP_CIMA_AUTH0_DOMAIN as string,
    clientId: process.env.REACT_APP_CIMA_AUTH0_CLIENT_ID as string,
    audience: process.env.REACT_APP_CIMA_AUTH0_AUDIENCE as string,
    redirectUri: window.location.origin + '/callback',
};
